import { Combobox } from '@consta/uikit/Combobox'
import { Select } from '@consta/uikit/Select'
import { Text } from '@consta/uikit/Text'
import type { SegyHeaderCoordsType } from '@core/core/types'
import cn from 'classnames'
import type { Nullable } from 'common/types'
import type { FC } from 'react'

import { optionHeaderTypes } from '../../MasterImportData'
import type { OptionHeaderType } from '../../types'
import css from './Setup.css'
import type { CoordinatesFieldsProps as Props } from './types'

export const CoordinatesFields: FC<Props> = ({
  isPadding = false,
  coordProps,
  coordValue,
  setHeaderCoordsValue,
}) => {
  const { name, values, coordName } = coordProps
  const cordProps = coordValue?.[coordName]

  const setComboboxValue = (value: Nullable<{ label: string }>) => {
    if (!value || !coordValue) return
    const offset = parseInt(value.label, 10)
    const newValue: SegyHeaderCoordsType = {
      ...coordValue,
      [coordName]: { offset: isNaN(offset) ? undefined : offset, type: cordProps?.type },
    }
    setHeaderCoordsValue(newValue)
  }
  const setSelectValue = (value: Nullable<OptionHeaderType>) => {
    if (!coordValue) return
    const newValue: SegyHeaderCoordsType = {
      ...coordValue,
      [coordName]: { offset: cordProps?.offset, type: value?.name },
    }
    setHeaderCoordsValue(newValue)
  }

  const comboValue = cordProps?.offset?.toString()
  const selectValue = cordProps?.type

  const containerClass = cn(css.containerFields, css.coordinatesPadding, {
    [css.containerFieldsPadding]: isPadding,
  })

  return (
    <div className={containerClass}>
      <Text size="s" view="secondary" className={css.coordinatesNameText}>
        {name}
      </Text>
      <Combobox
        name={name}
        className={css.coordinatesCombobox}
        size="s"
        items={values}
        value={values.find(value => value.label === comboValue)}
        getItemKey={item => item.label}
        status={!comboValue ? 'alert' : undefined}
        data-testid={`coord_offset_${name}`}
        onChange={setComboboxValue}
      />
      <Select
        items={optionHeaderTypes}
        getItemKey={item => item.label}
        getItemLabel={item => item.label}
        value={optionHeaderTypes.find(header => header.name === selectValue)}
        size="s"
        className={css.coordinatesSelect}
        status={!selectValue ? 'alert' : undefined}
        data-testid={`coord_type_${name}`}
        onChange={setSelectValue}
      />
    </div>
  )
}
